var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88263 5.14562C9.187 5.40604 9.67168 5.39823 9.96519 5.12817C10.2587 4.85811 10.2499 4.42808 9.94552 4.16766L5.17969 0.0900359L0.413855 4.16766C0.109483 4.42808 0.100677 4.85811 0.394185 5.12817C0.687694 5.39823 1.17237 5.40604 1.47674 5.14562L5.17969 1.9774L8.88263 5.14562Z",
    fill: "#1E6978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17812 5.45553L2.32068 7.90018C2.01735 8.15971 1.53344 8.15191 1.24099 7.88282C0.949718 7.61483 0.958441 7.18882 1.26055 6.93034L5.07321 3.66824H5.28304L9.0957 6.93034C9.39781 7.18882 9.40653 7.61483 9.11526 7.88282C8.82281 8.15191 8.3389 8.15971 8.03557 7.90018L5.17812 5.45553Z",
    fill: "#1E6978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.7cd3ad3747f50b82417074c90952decf.svg";
export { ForwardRef as ReactComponent };